<style lang="less" scoped>
    .repair-info-div{
        margin:10px 200px;
        font-size: 14px;
        line-height: 32px;
        color: #8F9BB3;
    }
    .margin-tb-40{
        margin-top:40px;
    }
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">维修详情</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="维修工单">
                                <el-input v-model="detailForm.repairNo" size="small" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="维修人" prop="repairPerson">
                                <el-input v-model="detailForm.repairPerson" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="维修状态" prop="repairStatus">
                                <el-select class="full-width" v-model="detailForm.repairStatus" size="small" clearable>
                                    <el-option label="未维修" value="01"></el-option>
                                    <el-option label="已维修" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="维修结果" prop="repairResult">
                                <el-select class="full-width" v-model="detailForm.repairResult" size="small" clearable>
                                    <el-option label="未恢复" value="01"></el-option>
                                    <el-option label="已恢复" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="维修时间（天）" prop="repairDateNum">
                                <el-input-number v-model="detailForm.repairDateNum" size="small"  @change="handleChange" :min="1" :max="9999" label="描述文字"></el-input-number>
                            </el-form-item>
                            <el-form-item label="运营商回执" prop="corpReturn">
                                <el-input v-model="detailForm.corpReturn" size="small" type="textarea"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="维修记录">
                                <el-input v-model="detailForm.remark" size="small" type="textarea"></el-input>
                            </el-form-item> -->
                        </div>
                        <div class="flex-1">
                            <div class="repair-info-div">
                                <div>
                                    <div class="flex">
                                        <div>运营商：</div>
                                        <div>{{detailForm.dealName}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>所属电站：</div>
                                        <div>{{detailForm.stationName}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>电站编号：</div>
                                        <div>{{detailForm.stationNo}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>充电桩编号：</div>
                                        <div>{{detailForm.pileNo}}</div>
                                    </div>
                                </div>
                                <div class="margin-tb-40">
                                    <div class="flex">
                                        <div>申请人：</div>
                                        <div>{{detailForm.applyPerson}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>申请人电话：</div>
                                        <div>{{detailForm.applyPhone}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>申请日期：</div>
                                        <div>{{detailForm.applyTime}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>申请原因：</div>
                                        <div>{{detailForm.applyReason}}</div>
                                    </div>
                                </div>
                                <div class="margin-tb-40">
                                    <div class="flex">
                                        <div>操作人：</div>
                                        <div>{{detailForm.lastModifiedByName}}</div>
                                    </div>
                                    <div class="flex">
                                        <div>最近操作时间：</div>
                                        <div>{{detailForm.lastModifiedWhen}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>    
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:true,
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                // 默认值设置
                detailForm: {},
                activeName: '',
            }
        },
        methods: {
            init() {
                this.getFormInfo();
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.pile.pilerepair+'/'+_.$route.params.id,function(res){
                     _.detailForm = res.data.data;
                });
            },
            handleChange(value) {
                console.log(value);
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$S.submitForm(_, _.$A.pile.pilerepair, _.editFlag, _.detailForm, pageConfig.tableEditObj.editRouter);
                    }
                });
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>